import Modal from 'react-bootstrap/Modal';
import React, { useContext, useState, useEffect, useRef,useCallback } from 'react';
import DataContext from '../../Component/context';
import moment from "moment-timezone";
import { toast } from 'react-toastify'
const DeliveryTimeSlotModal = () => {
    const timeZone = "Australia/Sydney";
    const contextValues = useContext(DataContext)
    const didMountRef = useRef(true)
    const [dates, setDates] = useState([]);
    const [currentActiveDate, setCurrentActiveDate] = useState('');

    const getScheduleTime = useCallback((newDate = moment().tz(timeZone).format("YYYY-MM-DD")) => {
        const today = moment().tz(timeZone).startOf("day");
        const selectedDate = moment.tz(newDate, "YYYY-MM-DD", timeZone).startOf("day");
    
        setCurrentActiveDate(selectedDate.format("YYYY-MM-DD"));
    
        const isSameDate = today.isSame(selectedDate, "day");
    
        if (!isSameDate) {
            contextValues.setLunchDayTimeStatus(false);
            contextValues.setDinnerDayTimeStatus(false);
            contextValues.setMenuSchedule("lunch");
            return;
        }
    
        const currentTime = moment().tz(timeZone).format("HH:mm:ss");
    
        if (contextValues?.settingData) {
            const { lunch_end_time, dinner_end_time, pickup_lunch_end_time, pickup_dinner_end_time } = contextValues.settingData;
    
            let lunchEndTime, dinnerEndTime;
    
            if (contextValues.orderRecieveStatus === "delivery") {
                lunchEndTime = lunch_end_time;
                dinnerEndTime = dinner_end_time;
            } else {
                lunchEndTime = pickup_lunch_end_time;
                dinnerEndTime = pickup_dinner_end_time;
            }
    
            // Update lunch status
            if (currentTime > lunchEndTime) {
                contextValues.setLunchDayTimeStatus(true);
                contextValues.setMenuSchedule("dinner");
            } else {
                contextValues.setLunchDayTimeStatus(false);
            }
    
            // Update dinner status
            if (currentTime > dinnerEndTime) {
                contextValues.setDinnerDayTimeStatus(true);
                contextValues.setMenuSchedule("lunch");
            } else {
                contextValues.setDinnerDayTimeStatus(false);
            }
        } else {
            console.error("contextValues or settingData is not properly defined.");
        }
    }, [
        contextValues?.setLunchDayTimeStatus,
        contextValues?.setDinnerDayTimeStatus,
        contextValues?.setMenuSchedule,
        contextValues?.orderRecieveStatus,
        contextValues?.settingData
    ]);

    useEffect(() => {
        if (didMountRef.current) {
            const productSelectedDay = contextValues?.cartItemDeliverySlot?.product_selected_day;
            const productType = contextValues?.cartItemDeliverySlot?.product_type;
            let nextDays = [];

            if (productType === 1) {
                if (productSelectedDay) {
                    nextDays = getNextDays(productSelectedDay, 7).map(date => 
                        moment(date).tz(timeZone).format("YYYY-MM-DD")
                    );
                }
            } else if (productType === 0) {
                nextDays = Array(7).fill().map((_, i) =>
                    moment().tz(timeZone).add(i, "days").format("YYYY-MM-DD")
                );
            }
    
            setDates(nextDays);
    
            const selectedDate = contextValues?.cartItemDeliverySlot?.product_selected_date;
            console.log('selectedDate', selectedDate);
            
            if (selectedDate) {
                setCurrentActiveDate(selectedDate);
                getScheduleTime(selectedDate);
            }
    
            contextValues.setMenuSchedule(contextValues?.cartItemDeliverySlot?.product_time);
    
            // Move didMountRef reset inside the if condition
            didMountRef.current = false;
        }
    }, [getScheduleTime, contextValues]);

    function getNextDays(productSelectedDay, count = 5) {
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const dayToFind = daysOfWeek.indexOf(productSelectedDay);

        if (dayToFind === -1) {
            throw new Error(`Invalid day: ${productSelectedDay}. Please provide a valid day (e.g., 'Monday', 'Tuesday').`);
        }

        const result = [];
        let currentDate = moment().tz(timeZone);
    
        while (currentDate.day() !== dayToFind) {
            currentDate.add(1, 'day');
        }

        for (let i = 0; i < count; i++) {
            result.push(currentDate.clone().format("YYYY-MM-DD"));
            currentDate.add(7, 'days');
        }

        return result;
    }

    const onClose = () => {
        contextValues.setToggleDeliveryTimeSlotModal(!contextValues.toggleDeliveryTimeSlotModal)
    }

    const onChangeScheduleStaus = (type) => {
        if (type === 'lunch') {
            if (!contextValues.lunchDayTimeStatus) {
                getScheduleTime(currentActiveDate)
                contextValues.setMenuSchedule(type);
            } else {
                toast.error("Lunch order time has been ended for today");
            }
        }
        if (type === 'dinner') {
            if (!contextValues.dinnerDayTimeStatus) {
                getScheduleTime(currentActiveDate)
                contextValues.setMenuSchedule(type);
            } else {
                toast.error("Dinner order time has been ended for today");
            }
        }
    }

    const chooseDateTimeSlot = () => {
        const { lunchDayTimeStatus, dinnerDayTimeStatus, menuSchedule, cartItemDeliverySlot } = contextValues;
    
        if ((lunchDayTimeStatus && menuSchedule === 'lunch') || (dinnerDayTimeStatus && menuSchedule === 'dinner')) {
            toast.error("Please select Delivery Options");
            return false;
        }
    
        if (menuSchedule === 'lunch' && lunchDayTimeStatus) {
            toast.error("Lunch order time has ended for today");
            return false;
        }
        if (menuSchedule === 'dinner' && dinnerDayTimeStatus) {
            toast.error("Dinner order time has ended for today");
            return false;
        } 
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        const currentDate = moment.tz(currentActiveDate, 'YYYY-MM-DD', timeZone).format('YYYY-MM-DD');
        const currentDay = moment.tz(currentActiveDate, 'YYYY-MM-DD', timeZone).format('dddd');
    
        const updatedCart = cart.map(cartItem =>
            cartItem.product_sesion_id === cartItemDeliverySlot?.product_sesion_id
                ? {
                    ...cartItem,
                    product_time: menuSchedule,
                    product_day: currentDay,
                    product_selected_day: currentDay,
                    product_selected_date: currentDate
                }
                : cartItem
        );
    
        if (!cart.some(cartItem => cartItem.product_sesion_id === cartItemDeliverySlot?.product_sesion_id)) {
            toast.error("Item not found");
            return false;
        }
    
        updateCartInSession(updatedCart);
    };
    

    const updateCartInSession = (updatedCart) => {
        localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
        contextValues.setCartSessionData(updatedCart)
        contextValues.setCartCount(updatedCart.length)
        onClose()
    };

    return (
        <>
            <Modal className="addressModal bottom" show={contextValues.toggleDeliveryTimeSlotModal} onHide={(e) => { onClose() }}>
                <div className='addressModalContent'>
                    <button type="button" className="addressModalclose" onClick={() => { onClose() }}><i className="ri-close-line"></i></button>
                    <div className='addressModalContentInner'>
                        <div className="mb-20">
                            <h5>Choose your {contextValues.orderRecieveStatus} Date</h5>
                        </div>
                        <div className='datelist'>
                            <ul>
                                {dates && dates.length > 0 && dates.map((dateData, index) => {
                                    return (
                                        <li
                                            key={index}
                                            className={currentActiveDate === dateData ? 'active' : ''}
                                            onClick={() => getScheduleTime(dateData)}
                                        >
                                            <span className='date'>{moment(dateData).format('D')}</span>
                                            {contextValues?.cartItemDeliverySlot?.product_type === 1 ? <span className='war tx-12 tx-gray'>{moment(dateData).format('MMM')}</span> : <span className='war tx-12 tx-gray'>{moment(dateData).format('ddd')}</span>}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <h5>{contextValues.orderRecieveStatus.charAt(0).toUpperCase() + contextValues.orderRecieveStatus.slice(1)} Options</h5>
                        <div className="checkbox-body mb-20">
                            <div className={`deilverop_box mt-10  ${contextValues.lunchDayTimeStatus ? 'disable' : contextValues.menuSchedule === 'lunch' ? 'active' : ''}`} onClick={() => { onChangeScheduleStaus('lunch') }}>
                                <div className="deilverop_box_det">
                                    <div className="deilverop_box_det_icon">
                                        <img src='/img/lunch.png' alt="lunch time"></img>
                                    </div>
                                    <div className="deilverop_box_det_cont">
                                        <h6 className="mb-0">Lunch Time</h6>
                                        {contextValues.orderRecieveStatus === 'delivery' ? <p className="mb-0 tx-12 line18">Order will be deliver before lunch time (1:00pm)</p>: <p className="mb-0 tx-12 line18">Please leave a note specifying a suitable pickup time.</p>}
                                        {contextValues.lunchDayTimeStatus &&(<>
                                            <p className="mb-0 tx-12 text-danger line18">Lunch order time has been ended for today ,  so lunch is no longer availale for today, order it for dinner.</p>
                                            <p className="mb-0 tx-12 text-success fw600">Pickup might still be possible.</p>
                                        </>)}
                                    </div>
                                </div>
                            </div>
                            <div className={`deilverop_box mt-10  ${contextValues.dinnerDayTimeStatus ? 'disable' : contextValues.menuSchedule === 'dinner' ? 'active' : ''}`} onClick={() => { onChangeScheduleStaus('dinner') }}>
                                <div className="deilverop_box_det">
                                    <div className="deilverop_box_det_icon">
                                        <img src='/img/dinner.png' alt="dinner time"></img>
                                    </div>
                                    <div className="deilverop_box_det_cont">
                                        <h6 className="mb-0">Dinner Time</h6>
                                        {contextValues.orderRecieveStatus === 'delivery' ? <p className="mb-0 tx-12 line18">Order will be deliver before dinner time (7:00pm)</p>: <p className="mb-0 tx-12 line18">Please leave a note specifying a suitable pickup time.</p>}
                                        {contextValues.dinnerDayTimeStatus && (<>
                                            <p className="mb-0 tx-12 text-danger line18">Dinner order time has been ended for today ,  so dinner is no longer availale for today, order it for lunch.</p>
                                            <p className="mb-0 tx-12 text-success fw600">Pickup might still be possible.</p>
                                        </>
                                    )}
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <h6 className='text-danger'>Note:</h6>
                                <p className='mb-0 tx-14'>- For urgent orders and deliveries please call <a href="tel:0490316092">0490 316 092</a> to discuss potential options (Extra Delivery Charges Apply)
                                </p>
                                <p className='mb-0 tx-14'>- For Areas outside our regular delivery area, call <a href="tel:0490316092">0490 316 092</a> to organise special delivery (Extra Delivery Charges Apply)
                                </p>
                            </div>
                        </div>
                        <button type='button' className='btn btn-primary btn-lg btn-full' onClick={(e) => chooseDateTimeSlot()}>Proceed to checkout</button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default DeliveryTimeSlotModal